/*jshint ignore:start */
var APP = APP || {};

(function()
{
	APP.Abstract = Class.extend(
	{
		init : function()
		{
        	this.$ = {};
			this.events = {};
		},
		
		remove : function()
		{
			this.off();
		},

		//--------  listener
		on : function(name,f)
		{
			this.events[name] = new signals.Signal();
			this.events[name].add(f);
		},

		off : function(name,f)
		{
			if(f != undefined)
			{
				this.events[name].remove(f);
				delete this.events[name];
			}	
			else if( name != undefined)
			{
				this.events[name].removeAll();
				delete this.events[name];
			}	
			else
			{
				for(var name in this.events)
				{
					this.off(name);
				}
			}
		},

		trigger : function(name,obj)
		{
			if( this.events[name] == undefined )
				return;

			this.events[name].dispatch(obj);
		}
	})

})();
/*jshint ignore:start */
var APP = APP || {};

(function($) {
	APP.Conf = Class.extend({
		defaults : {
			page : '',
			env : "production",
			baseUrl : null,
			locale : "fr",
			device : "desktop",
			mode : "large",
			isAndroid : navigator.userAgent.toLowerCase().indexOf("android") > -1,
			isiOS : (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false ),
			isTouch : Modernizr.touch,
			overEvent : (Modernizr.touch) ? 'touchstart' : 'mouseover',
			clickEvent : (Modernizr.touch) ? 'touchstart' : 'click',
			downEvent : (Modernizr.touch) ? 'touchstart' : 'mousedown',
			upEvent : (Modernizr.touch) ? 'touchend' : 'mouseup',
			moveEvent : (Modernizr.touch) ? 'touchmove' : 'mousemove',
			historyHtml5 : Modernizr.history,
			hasTransforms : Modernizr.csstransforms,
			hasTransforms3d : Modernizr.csstransforms3d,
			viewport: {height:0, width:0}
		},

		init : function(options) {
			this.s = $.extend(this.defaults, options);

			this.$ = {
				body : $("body"),
				main : $(".page"),
				html : $('html'),
				win : $(window),
				doc : $(document)
			};

			if (this.s.isTouch) {
				var wh = window.innerHeight;
				var ww = window.innerWidth;
				this.s.viewport.height = wh ? wh : this.$.win.height();
				this.s.viewport.width = ww ? ww : this.$.win.width();
			} else {
				this.s.viewport.height = this.$.win.height();
				this.s.viewport.width = this.$.win.width();
			}

			this.initLog();
		},

		initLog : function() {
			if (this.s.env=="development")
			{
			    window.log = function f(){ log.history = log.history || []; log.history.push(arguments); if(this.console) { var args = arguments, newarr; args.callee = args.callee.caller; newarr = [].slice.call(args); if (typeof console.log === 'object') log.apply.call(console.log, console, newarr); else console.log.apply(console, newarr);}};
			(function(a){function b(){}for(var c="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),d;!!(d=c.pop());){a[d]=a[d]||b;}})
			(function(){try{console.log();return window.console;}catch(a){return (window.console={});}}());
			}
			else
			{
			    window.log = function f(){};
			}
		}
	});

})(jQuery);


/**
 * Core
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};


(function($) {
	APP.Core = APP.Abstract.extend( {
		init : function(options) {
			this._super();

			var that = this;

			$.validator.setDefaults({
  				highlight: function(element, errorClass, validClass) {
  					var t = $(element).closest('.form__field')
				    t.addClass(errorClass).removeClass(validClass);
				    $(element).addClass(errorClass).removeClass(validClass);
				},
				unhighlight: function(element, errorClass, validClass) {
					var t = $(element).closest('.form__field')
				    t.removeClass(errorClass).addClass(validClass);
				    $(element).removeClass(errorClass).addClass(validClass);
				},
				errorPlacement: function(error,element) {
					return true;
				},
				showErrors: function(errorMap, errorList) {
					var errors = this.numberOfInvalids();
					var modal = new APP.Modal();
					if (errors == 0) {
						modal.removeAll();
					}

					this.defaultShowErrors();
				},
				invalidHandler: function(event, validator) {
					var errors = validator.numberOfInvalids();
					if (errors) {
						var html = '<ul class="form-errors">';
						for (var i in validator.errorList) {
							html += '<li class="form-errors__item"><label id="" for="' + $(validator.errorList[i].element).attr('id') + '">' + validator.errorList[i].message + '</label></li>';
						} 
						html += '</ul>';

						var modal = new APP.Modal({text: html});
					}
				}
			});

			this.config = new APP.Conf(options)
			
			this.header = new APP.Header(this.config);
			this.footer = new APP.Footer(this.config);

			if (this.config.s.page === 'home') {
				this.page = new APP.Home(this.config);
			} else {
				this.page = new APP.PageAbstract(this.config);
			} 

			this.config.$.win.on('resize orientationchange',$.proxy(this.resize, this)).trigger('resize');

			if (this.config.s.isTouch)	{
				FastClick.attach(document.body);
			}

			this.header.startup();

			if (this.page !== null) {
				this.page.startup();
			}

			this.footer.startup();
		},

		/* --- listener resize */
		resize : function() {
			var wh = window.innerHeight;
			var ww = window.innerWidth;
			this.config.s.viewport.height = wh ? wh : this.config.$.win.height();
			this.config.s.viewport.width = ww ? ww : this.config.$.win.width();

			this.config.s.mode = 'small';
			if (this.config.s.viewport.width >= 768) {
				this.config.s.mode = 'medium';
			}
			if (this.config.s.viewport.width >= 1008) {
				this.config.s.mode = 'large';
			}
			if (this.config.s.viewport.width >= 1272) {
				this.config.s.mode = 'xlarge';
			}

			this.header.resize();

			if (this.page !== null) {
				this.page.resize();
			}

			this.footer.resize();
		}
	});

})(jQuery);


'use strict';
(function($) {
	$('body').addClass('has-js');
})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.Footer = APP.Abstract.extend({

		/* ==========================================================================
			Init
		========================================================================== */
		init : function(config) {
			this._super();

			this.config = config;
			
			this.initCookieBar();
		},
		

		/* ==========================================================================
			Startup
		========================================================================== */
		startup : function() {
			
		},

		/* ==========================================================================
			initCookieBar
		========================================================================== */
		initCookieBar: function(){
			var cookiebar = $('.cookie-bar');
			var close = $('.cookie-bar__close');

			if (Cookies.get('cookiebar') != 'hide') {
				cookiebar.show();
			}

			close.click(function(e) {
				cookiebar.fadeOut();

				Cookies.set('cookiebar', 'hide');
				return false;
			});
		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {
			
		}

	});

})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.Header = APP.Abstract.extend({

		/* ==========================================================================
			Init
		========================================================================== */
		init : function(config) {
			this._super();


			var that = this;

			this.config = config;

			$(document).on('click', '.site-header__toggle', function(e){
				e.preventDefault();

				$('body').toggleClass('isMenuOpened');
			});

			$('.main-nav__link').click(function(e){
				if (APP.Toolbox.isMobile() && $(this).closest('.main-nav__item--single').length == 0) {
					e.preventDefault();
					e.stopImmediatePropagation();

					if ($('.nav-expand', $(this).parent()).is(':visible')) {
						$('.main-nav__item').removeClass('isActive');
					} else {
						$('.main-nav__item').removeClass('isActive');
						$(this).closest('.main-nav__item').addClass('isActive');
					}
				}
			});

			$('.main-nav__link').each(function() {
				var handler = $(this).prop('onclick');
			    $(this).prop('onclick', null);
			    $(this).click(handler);
			});
		},
		

		/* ==========================================================================
			Startup
		========================================================================== */
		startup : function() {
			
		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {
		}

	});

})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.Loader = APP.Abstract.extend({

		data: {
			element: $('<div class="loader"><div class="loader__inner"></div></div>')
		},
		/* ==========================================================================
			Init
		========================================================================== */
		init : function(container) {
			this._super();

			this.container = container;
		},

		/* ==========================================================================
			Startup
		========================================================================== */
		startup : function() {

			this.container.prepend(this.data.element);
		},

		/* ==========================================================================
			Resize
		========================================================================== */
		remove : function() {
			this.data.element.remove();
			this.container = null;
		}

	});

})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.Modal = APP.Abstract.extend({

		data: {
			element: $('<div class="modal" tabindex="-1" role="dialog">\
							<div class="modal__background"></div>\
							<div class="modal__helper">\
								<div class="modal__container">\
									<div class="modal__close" aria-label="Close"><i class="icon-close"></i></div>\
									<div class="modal__content">Lorem</div>\
								</div>\
							</div>\
						</div>')
		},

		/* ==========================================================================
			Init
		========================================================================== */
		init : function(options) {
			this._super();

			var that = this;

			this.data.element.removeClass('modal--dialog');

			if (options) {
				that.removeAll(true);

				if (options.text) {
					$('.modal__content', this.data.element).html('<p>' + options.text + '</p>');

					this.data.element.addClass('modal--dialog');
				}

				if (options.confirm) {
					this.data.element.addClass('modal--dialog');

					$('.modal__content', this.data.element).append('\
						<div class="modal__choices">\
							<a class="button modal__choice modal__no" data-value="0">' + APP.Translator[options.locale]['Non'] + '</a>\
							<a class="button modal__choice modal__yes" data-value="1">' + APP.Translator[options.locale]['Oui'] + '</a>\
						</div>');

					$('.modal__choice', this.data.element).click(function(e) {
						e.preventDefault();
						options.confirm.call(this, $(this).data('value'));

						that.removeAll();
					});
				}

				$('body').append(this.data.element);
				$(document).on('click', '.modal__close, .modal__helper', function(e) {
					e.preventDefault();
					that.removeAll();
				});

				$(document).on('click', '.modal__container', function(e) {
					e.stopImmediatePropagation();
				});

				TweenLite.set(this.data.element, {autoAlpha:1});

				TweenLite.set($('.modal__background', this.data.element), {autoAlpha:0});
				TweenLite.set($('.modal__helper', this.data.element), {y: '-50px', autoAlpha:0});
				TweenLite.to($('.modal__background', this.data.element), 0.4, {autoAlpha:1, ease: Expo.easeOut});
				TweenLite.to($('.modal__helper', this.data.element), 0.5, {y: 0, autoAlpha:1, ease: Expo.easeOut});
			}
		},

		/* ==========================================================================
			Remove all
		========================================================================== */
		removeAll : function(force) {
			var that = this;

			$(document).off('click', '.modal__close, .modal__helper');
			$(document).off('click', '.modal__container');
			$('.modal__choice', this.data.element).off('click');

			if (force) {
				$('.modal').remove();
				$('.modal__choices').remove();
			} else {
				TweenLite.to($('.modal'), 0.3, {autoAlpha:0, ease: Expo.easeOut, onComplete:function() {
					$('.modal').remove();
					$('.modal__choices').remove();
				}, clearProps:'All'});
			}
		}

	});

})(jQuery);
/**
 * Default
* Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.PageAbstract = APP.Abstract.extend({

		/* ==========================================================================
			Data
		========================================================================== */
		data : {

		},

		/* ==========================================================================
			Init
		========================================================================== */
		init: function(config) {
			this._super();

			this.config = config;

			this.initFormElements();
			this.initArticlePush();
            this.initEsi();

			//newsletter form
			$("#newsletterFooterForm").ajaxForm(function(response){
				$("#newsletterFooterForm").find(".form__response").addClass('show');
			});

			var facebook_link = $(".social-link-facebook");
			facebook_link.click(function(e){
				e.preventDefault();
				var self = $(this);
				FB.ui({
				  method: 'share',
				  href: self.data('url'),
				}, function(response){});
			});

			var gplus_link = $(".social-link-gplus");
			gplus_link.click(function(e){
				e.preventDefault();
				var self = $(this);
				window.open(self.data('url'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
				return false;
			});

			var pinterest_link = $(".social-link-pinterest");
			pinterest_link.click(function(e){
				e.preventDefault();
				var self = $(this);
				window.open(self.data('url'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
				return false;
			});

			$('.video-js').each(function(e, i){
				var myPlayer = videojs($(this).attr('id'), { fluid: true, preload: 'metadata' });
			});

		},

		/* ==========================================================================
			initFormElements
		========================================================================== */
		initFormElements: function() {
			var that = this;

			// infield label
			$(document).on('click', '.form__field--infield label', function(e){
				var target = $(this).closest('.form__field--infield');
				target.addClass('isActive');
				$('input', target).focus();
			});

			$(document).on('focus', '.form__field--infield input, .form__field--infield textarea', function(e){
				var target = $(this).closest('.form__field--infield');
				target.addClass('hasFocus');
				target.addClass('isActive');
			});

			$(document).on('focusout', '.form__field--infield input, .form__field--infield textarea', function(e){
				var target = $(this).closest('.form__field--infield');

				target.removeClass('hasFocus');

				if($(this).val().length == 0) {
					$(target).removeClass('isActive');
				}
			});

			$(document).on('change', '.form__field--infield input, .form__field--infield textarea', function(e){
				that.checkInfieldlabel($(this).closest('.form__field--infield'));
			});

			setInterval(function(){
				$('.form__field--infield').each(function() {
					that.checkInfieldlabel($(this));
				});
			}, 1000);

			$(document).on('click', ".confirm", function(e){
				e.preventDefault();
				var self = this;

				var modal = new APP.Modal({
					text: $(this).data('text'),
					confirm: function(result){
						if(result == 1) document.location.href = $(self).attr('href');
					},
					locale: that.config.s.locale
				});
			});

			$('.inlineSVG').each(function(){
	            var $img = $(this);
	            var imgID = $img.attr('id');
	            var imgClass = $img.attr('class');
	            var imgURL = $img.attr('src');

	            $.get(imgURL, function(data) {
	                // Get the SVG tag, ignore the rest
	                var $svg = $(data).find('svg');

	                // Add replaced image's ID to the new SVG
	                if(typeof imgID !== 'undefined') {
	                    $svg = $svg.attr('id', imgID);
	                }
	                // Add replaced image's classes to the new SVG
	                if(typeof imgClass !== 'undefined') {
	                    $svg = $svg.attr('class', imgClass+' replaced-svg');
	                }

	                // Remove any invalid XML tags as per http://validator.w3.org
	                $svg = $svg.removeAttr('xmlns:a');

	                // Replace image with new SVG
	                $img.replaceWith($svg);

	            }, 'xml');

	        });


		},

		/* ==========================================================================
			init Article push
		========================================================================== */
		initArticlePush: function(){

			$(document).on('click', '.article-push', function(e){
				var _self = $(this);
				var link = _self.find('a:first');

				if(link.length > 0) document.location.href = link.attr('href');
			});

		},

		/* ==========================================================================
			checkInfieldlabel
		========================================================================== */
		checkInfieldlabel: function(target) {
			if (!target.hasClass('hasFocus')) {
				if($('input', target).val().length == 0) {
					$(target).removeClass('isActive');
				}  else {
					$(target).addClass('isActive');
				}
			}
		},

        initEsi: function(){
            $(".renderEsi").each(function(i, e){
                var _self = $(e);
                var _url = _self.data('url');
                $.ajax({
                    url: _url,
                    success: function(response){
                        _self.html(response);
                    }
                });
            });
        },

		/* ==========================================================================
			Startup
		========================================================================== */
		startup: function() {

		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {

		}

	});

})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP = APP || {};

(function($) {
	APP.Home = APP.PageAbstract.extend({

		/* ==========================================================================
			Defaults
		========================================================================== */
		defaults : {
			pagination: 1
		},

		/* ==========================================================================
			Init
		========================================================================== */
		init : function(config) {
			this._super(config);

			//mecanic to see more articles
			var that = this;
			that.pagination = 2;

			var _home__articles = $(".home__articles .articles");

			$(".home__articles .more-cta .cta").click(function(e) {
				var _self = $(this);
				var _url = _self.data('url');
				$.ajax({
					url: _url,
					data: {page: that.pagination},
					success: function(response){
						_home__articles.append(response);
					}
				})

				that.pagination++;
			});


		},

		/* ==========================================================================
			Startup
		========================================================================== */
		startup : function() {
			this._super();
		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {
			this._super();
		}

	});

})(jQuery);
var APP = APP || {};

(function()
{
	APP.Toolbox =
	{
		link: function(){
			var target = "";
			for (var i = 0;i < arguments.length - 1; i++) {
				target += arguments[i].replace('||','//').replace('|','/');
			}

			if((arguments[i].shiftKey) || (arguments[i].metaKey)) {
				window.open(target, '_blank');
			} else {
				window.location = target;
			}

			return false;
		},
		isMobile: function() {
			return $('.site-header__toggle').is(':visible');
		}
	}

})();
var APP = APP || {};

(function() {
	APP.Translator = {
		locale: 'fr',
		fr: {
			'Oui': 'Oui',
			'Non': 'Non'
		},
		de: {
			'Oui': 'Ja',
			'Non': 'Nein'
		}
	}

})();